export enum FlexibleFitmentEngineWorkspaceCapabilityAccessOperation {
    create = "ec06964d-d5c8-4df7-9bde-4a946a48fe61",
    read = "cfd00ff9-3e41-4f86-b5e5-873bfff272d5",
    update = "9ca2af0e-c495-47c5-8b94-80152487dfc1",
    delete = "f641b743-c7fa-44b7-862e-00cdd6717603",
}
